import { axios } from '@utils';

export default {
  namespaced: true,
  state: {
    document: {},
  },
  mutations: {
    updateDocument(state, document) {
      state.document = document;
    },
  },
  actions: {
    async validadeAccessToken({ commit }, accessToken) {
      try {
        const response = await axios.post('/validate_accesses/certify.json', {
          access_token: accessToken,
        });
        const payload = response.data;
        commit('updateDocument', payload.document);
        return payload;
      } catch (error) {
        throw error.response.data.errors;
      }
    },
  },
  getters: {
    validDocument(state) {
      return state.document;
    },
  },
};
